module.exports = "/assets/data/63f8d29be73f8750d3c16fd96fb8c110-BL6.data.json";